import { FC, useEffect, useState } from "react";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Navbar from "@/components/navbar/navbar";
import HeaderItems, {
  HeaderItemsLeft,
  HeaderItemsRight,
} from "@/shared/components/header-items/HeaderItems";
import DashboardContentLayout from "@/shared/layouts/DashboardContentLayout";
import useUnsavedChangesBlocker from "@/shared/hooks/useUnsavedChangesBlocker";
import { AdRoutes } from "@/constants/ad-routes";
import useLeadForm from "../hooks/useLeadForm";
import LeadForm from "../components/LeadForm";

const AddLeadPage: FC = () => {
  const navigate = useNavigate();
  const [hasSaved, setHasSaved] = useState(false);

  const { leadForm, isLoading } = useLeadForm(() => {
    toast.success("Lead created successfully");
    // Flip the flag first so the unsaved-changes blocker is disabled before we
    // navigate; otherwise it would intercept our own post-save redirect.
    setHasSaved(true);
  });

  useUnsavedChangesBlocker(leadForm.dirty && !hasSaved);

  useEffect(() => {
    if (hasSaved) {
      navigate(AdRoutes.leads);
    }
  }, [hasSaved, navigate]);

  return (
    <DashboardContentLayout>
      <Navbar showAccountMenu>
        <HeaderItems>
          <HeaderItemsLeft
            breadcrumbs={[
              { label: "Leads", url: AdRoutes.leads },
              { label: "Add New Lead" },
            ]}
          />
          <HeaderItemsRight>
            <Button
              variant="outlined"
              disabled={isLoading || !leadForm.dirty || !leadForm.isValid}
              onClick={() => leadForm.submitForm()}
              data-testid="save-lead"
            >
              Save Lead
            </Button>
          </HeaderItemsRight>
        </HeaderItems>
      </Navbar>
      <LeadForm leadForm={leadForm} />
    </DashboardContentLayout>
  );
};

export default AddLeadPage;
